










import { Component, Vue } from "@/common";
@Component({})
export default class AppMain extends Vue {
  get cachedViews() {
    return this.$store.state.tagsView.cachedViews;
  }
  get key() {
    return this.$route.fullPath;
  }
  mounted() {}
}
